import {Component, ElementRef, OnChanges} from "@angular/core";


const INPUT_HOST_ATTRIBUTES = [
  'tfFormInput',
  'tfFormLabel',
  'tfFormTextarea'
];

const StyleClassesForHostAttributes = {
  'tfFormInput': ['form-control', 'tf-form-control'],
  'tfFormLabel': ['tf-form-input-label'],
  'tfFormTextarea': ['form-control', 'tf-form-control', 'tf-form-textarea'],
};

@Component({
  selector: 'input[tfFormInput],label[tfFormLabel],textarea[tfFormTextarea]',
  templateUrl: 'tf-form-input-field.component.html',
  styleUrls: ['tf-form-input-field.component.scss'],
  inputs: ['size', 'required']

})
export class TfFormInputFieldComponent implements OnChanges {

  constructor(private _elementRef: ElementRef) {

    for (const attr of INPUT_HOST_ATTRIBUTES) {

      if (this._hasHostAttributes([attr])) {
        StyleClassesForHostAttributes[attr].forEach((className) => {
          className != "none" && (this._getHostElement() as HTMLElement).classList.add(className);
        });
      }
    }
  }

  size: string;
  required: boolean;

  ngOnChanges() {

    if (this.size && this._hasHostAttributes(['tfFormInput'])) {
      const className = this.size == 'lg' ? 'tf-form-control-lg' : this.size == 'sm' ? 'tf-form-control-sm' : 'none';
      className != "none" && (this._getHostElement() as HTMLElement).classList.add(className);
    }

    if (this.required && this.required == true && this._hasHostAttributes(['tfFormInput'])) {
      (this._getHostElement() as HTMLElement).classList.add('tf-form-input-required');
    }

    if (this.required && this.required == true && this._hasHostAttributes(['tfFormLabel'])) {
      const child = document.createElement('span');
      child.innerHTML = '*';
      child.style.fontSize = '15px';
      child.style.fontWeight = '500';
      child.style.color = 'tf-colors.$tf-red';
      this._getHostElement().appendChild(child);
    }
  }


  _getHostElement() {
    return this._elementRef.nativeElement;
  }

  _hasHostAttributes(attributes: string[]) {
    return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
  }

}
